import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col} from "react-bootstrap";
import { LabelFieldComponent, LabelTextareaComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import PageLayout from "../../layouts/PageLayout";
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";


import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { showSim, updateSim } from "../../APIs/SimsRequests";

export default function SimDetailsPage() {

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
    const {id} = useParams();

    const { t } = useContext(TranslatorContext);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [nationality, setNationality] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [documentNumber, setDocumentNumber] = useState('');
    const [documentExpiryDate, setDocumentExpiryDate] = useState('');
    const [address, setAddress] = useState('');
    const [occupation, setOccupation] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [isBlocked, setIsBlocked] = useState('0');
    const [blockReason, setBlockReason] = useState('');
    const [type, setType] = useState('');
    const [image, setImage] = useState('');
    const [signatureImage, setSignatureImage] = useState('');
    const [documentImageFront, setDocumentImageFront] = useState('');
    const [documentImageBack, setDocumentImageBack] = useState('');
    const [supportDocument, setSupportDocument] = useState('');

    const [allowedSimsNumber, setAllowedSimsNumber] = useState(0);
    const [approvedSimsNumber, setApprovedSimsNumber] = useState(0);
    const [permissionLitterImage, setPermissionLitterImage] = useState('');
    const [created_at, setCreatedAt] = useState('');
    const [kycFile, setKycFile] = useState('');
    const [kycFileLink, setKycFileLink] = useState('');


    const [simNumber, setSimNumber] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [status, setStatus] = useState('');
    const [puk, setPuk] = useState('');
    const [rejectReason, setRejectReason] = useState('');
    const [contractFile, setContractFile] = useState('');
    const [contractFileLink, setContractFileLink] = useState('');
    const [createdBy, setCreatedBy] = useState('');
    const [simCreatedAt, setSimCreatedAt] = useState('');

    const [ableToUpdate, setAbleToUpdate] = useState(false);


    useEffect(()=> {
        if(id){
            showSimFunction();
        }
    },[]);

    const updateSimFunction = () => {
        updateSim(id,status,rejectReason).then((res) => {
            const notify = () => toast.success(res.data.message);
            notify();
            showSimFunction();
        }).catch((error) => {
            console.log(error);
        });
    }
    const showSimFunction = async () => {
        showSim(id).then(async(res)=> {
            // Sim Data
            setSimNumber(res.data.data.sim_number);
            setSerialNumber(res.data.data.serial_number);
            setStatus(res.data.data.status);
            setPuk(res.data.data.puk);
            setRejectReason(res.data.data.reject_reason);
            setContractFile(res.data.data.contract_file_encoded);
            setContractFileLink(res.data.data.contract_file);
            setCreatedBy(res.data.data.created_by);
            setSimCreatedAt(res.data.data.created_at);
            setAbleToUpdate(res.data.data.able_to_update);

            // customerData
            setName(res.data.data.customer.name);
            setEmail(res.data.data.customer.email);
            setPhoneNumber(res.data.data.customer.phone_number);
            setNationality(res.data.data.customer.nationality);
            setBirthDate(res.data.data.customer.birth_date);
            setDocumentExpiryDate(res.data.data.customer.document_expiry_date);
            setAddress(res.data.data.customer.address);
            setOccupation(res.data.data.customer.occupation);
            setDocumentType(res.data.data.customer.document_type);
            setImage(res.data.data.customer.image);
            setSignatureImage(res.data.data.customer.signature_image);
            setDocumentImageFront(res.data.data.customer.document_image_front);
            setDocumentImageBack(res.data.data.customer.document_image_back);
            setPermissionLitterImage(res.data.data.customer.permission_litter_image);
            setCreatedAt(res.data.data.customer.created_at);
            setAllowedSimsNumber(res.data.data.customer.allowed_sims_number);
            setApprovedSimsNumber(res.data.data.customer.approved_sims_number);
            setIsBlocked(res.data.data.customer.is_blocked?'1':'0');
            setType(res.data.data.customer.type);
            setBlockReason(res.data.data.customer.block_reason);
            setDocumentNumber(res.data.data.customer.document_number);
            setKycFile(res.data.data.customer.kyc_file_encoded);
            setKycFileLink(res.data.data.customer.kyc_file);
            setSupportDocument(res.data.data.customer.support_document_image);
        });
    }



    return (
        <PageLayout>
            <Row>
                <h6 className="mc-tab-card-title">{t('sim_data')}</h6>
                <div className="mc-card">
                    <div className="mc-tab-card">
                        <Row>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('serial_number')}  fieldSize="w-100 h-md" value={serialNumber} /></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('sim_number')}  fieldSize="w-100 h-md" value={simNumber} /></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('puk')}  fieldSize="w-100 h-md" value={puk} /></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('status')}  fieldSize="w-100 h-md" value={status} /></Col>
                            
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('created_by')}  fieldSize="w-100 h-md" value={createdBy?.name} /></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('created_at')}  fieldSize="w-100 h-md" value={simCreatedAt} /></Col>
                            
                            {
                                status == 'approved' && contractFileLink!=='' && contractFileLink !== null &&
                                <Col xl={6}>
                                    <h6 className="mc-divide-title mb-4">{t('contract_template')}</h6>
                                    <div className="mc-product-view-gallery" style={{border:'1px solid #ccc', borderRadius:'5px'}}>
                                        <iframe 
                                            src={`data:application/pdf;base64,${contractFile}`}
                                            // src={contractFileLink}
                                            width="100%" 
                                            height="650px"
                                            title="PDF Viewer"
                                            >
                                            <p>Your browser does not support PDFs. 
                                                <a href={contractFileLink}>Download the PDF</a>.
                                            </p>
                                        </iframe>
                                        
                                    </div>
                                </Col>
                            }
                        </Row>
                    </div>
                    
                </div>
                


                <h6 className="mc-tab-card-title">{t('customer_data')}</h6>
                <div className="mc-card">
                    <div className="mc-tab-card">
                        {
                            type == 'individual' ?
                            <Row>
                            <Col xl={4}>
                                <div className="mc-user-avatar-upload">
                                    <div className="mc-user-avatar">
                                        <img src={image || "/images/default.png"} alt="avatar" />
                                    </div>
                                </div>
                            </Col>
                            <Col xl={8}>
                                <Row>
                                    <Col xl={12}><LabelFieldComponent disabled type="text" label={t('fullname')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={name}/></Col>
                                    <Col xl={12}><LabelFieldComponent disabled type="text" label={t('email')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={email}/></Col>

                                </Row>
                            </Col>
                        </Row>
                        :
                        <Row>
                            
                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}><LabelFieldComponent disabled type="text" label={t('fullname')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={name}/></Col>
                                    <Col xl={12}><LabelFieldComponent disabled type="text" label={t('email')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={email}/></Col>

                                </Row>
                            </Col>
                        </Row>
                        }
                        
                    </div>
                    <div className="mc-tab-card">
                        <Row>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('phone_number')}  fieldSize="w-100 h-md" value={phoneNumber} onChange={(e)=> setEmail(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('nationality')}  fieldSize="w-100 h-md" value={nationality} onChange={(e)=> setEmail(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('birth_date')}  fieldSize="w-100 h-md" value={birthDate} onChange={(e)=> setEmail(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('document_number')}  fieldSize="w-100 h-md" value={documentNumber} onChange={(e)=> setDocumentNumber(e.target.value)}/></Col>

                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('document_expiry_date')}  fieldSize="w-100 h-md" value={documentExpiryDate} onChange={(e)=> setEmail(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('address')}  fieldSize="w-100 h-md" value={address} onChange={(e)=> setEmail(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('occupation')}  fieldSize="w-100 h-md" value={occupation} onChange={(e)=> setEmail(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('document_type')}  fieldSize="w-100 h-md" value={documentType} onChange={(e)=> setEmail(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('type')}  fieldSize="w-100 h-md" value={type} onChange={(e)=> setType(e.target.value)}/></Col>

                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('allowed_sims_number')}  fieldSize="w-100 h-md" value={allowedSimsNumber} onChange={(e)=> setAllowedSimsNumber(e.target.value)}/></Col>
                            <Col xl={6}><LabelFieldComponent disabled type="text" label={t('approved_sims_number')}  fieldSize="w-100 h-md" value={approvedSimsNumber} onChange={(e)=> setApprovedSimsNumber(e.target.value)}/></Col>

                            <Col xl={6}><LabelFieldComponent disabled label={t('status')}  fieldSize="w-100 h-md" option={[{id:'1',name:t("blocked")},{id:'0',name:t("clear")}]} value={isBlocked} onChange={(e)=> {console.log(e.target.value);setIsBlocked(e.target.value)}}/></Col>
                            {
                                isBlocked == '1' &&
                                <Col xl={12}><LabelTextareaComponent disabled label={t('block_reason')} fieldSize="w-100 h-5xl" value={blockReason} onChange={(e)=> setBlockReason(e.target.value)}/></Col>
                            }

                            
                            <Col xl={6}><LabelFieldComponent disabled type="disabled" label={t('creation date')}  fieldSize="w-100 h-md" value={created_at}/></Col>


                            <Col xl={6}>
                                <h6 className="mc-divide-title mb-4">{t('signature_image')}</h6>
                                <div className="mc-product-view-gallery">
                                    <img src={signatureImage} alt="product"/>
                                    
                                </div>
                            </Col>

                            <Col xl={6}>
                                <h6 className="mc-divide-title mb-4">{t('document_image_front')}</h6>
                                <div className="mc-product-view-gallery">
                                    <img src={documentImageFront} alt="product"/>
                                    
                                </div>
                            </Col>

                            {
                                documentImageBack &&
                                <Col xl={6}>
                                    <h6 className="mc-divide-title mb-4">{t('document_image_back')}</h6>
                                    <div className="mc-product-view-gallery">
                                        <img src={documentImageBack} alt="product"/>
                                        
                                    </div>
                                </Col>
                            }

                            {
                                supportDocument &&
                                <Col xl={6}>
                                <h6 className="mc-divide-title mb-4">{t('support_document')}</h6>
                                <div className="mc-product-view-gallery">
                                    <img src={supportDocument} alt="product"/>
                                    
                                </div>
                            </Col>
                            }
                            {
                                permissionLitterImage &&
                                <Col xl={6}>
                                <h6 className="mc-divide-title mb-4">{t('permission_litter_image')}</h6>
                                <div className="mc-product-view-gallery">
                                    <img src={permissionLitterImage} alt="product"/>
                                    
                                </div>
                            </Col>
                            }
                            {
                                kycFile!=='' && kycFile == null &&
                                <Col xl={6}>
                                    <h6 className="mc-divide-title mb-4">{t('customer_kyc')}</h6>
                                    <div className="mc-product-view-gallery">
                                        <iframe 
                                            src={`data:application/pdf;base64,${kycFile}`}
                                            width="100%" 
                                            height="650px"
                                            title="PDF Viewer"
                                            >
                                            <p>Your browser does not support PDFs. 
                                                <a href={kycFileLink}>Download the PDF</a>.
                                            </p>
                                        </iframe>
                                    </div>
                                </Col>
                            }
                            {
                                type === 'company' &&
                                <Col xl={6}>
                                <h6 className="mc-divide-title mb-4">{t('employee_id')}</h6>
                                <div className="mc-product-view-gallery">
                                    <img src={image} alt="product"/>
                                    
                                </div>
                            </Col>
                            }

                        </Row>
                    </div>
                </div>

                <div className="mc-card">
                    {
                        ableToUpdate &&
                        <LabelFieldComponent 
                            label={''}  
                            fieldSize="w-250 h-md" 
                            option={[{id:'pending',name:t("pending")},{id:'approved',name:t("approve")},{id:'rejected',name:t("reject")}]}
                            value={t(status)} 
                            disabled={!ableToUpdate}
                            onChange={(e)=> {
                                setStatus(e.target.value);
                            }}
                        />
                    }

                    {
                        status =='rejected' && <Col xl={12}><LabelTextareaComponent disabled={!ableToUpdate}
                            type="text" label={t('reject_reason')}  fieldSize="w-100 h-md" value={ rejectReason } onChange={(e)=> setRejectReason(e.target.value)}/></Col>

                    }
                    
                </div>
                {
                    ableToUpdate &&
                    <div className="mc-card">
                        <ButtonComponent className="mc-btn primary" icon="verified" text={t('submit')} onClick={()=>updateSimFunction()}/>
                    </div>
                }

            </Row>
        </PageLayout>
    )
}

